module.exports = __webpack_public_path__ + "static/vregattaHome-0c74ad9c123393369d0df9aa3b28eaa5.webp";